import Vue from 'vue'
import store from '../../vue/store'
import Toasted from 'vue-toasted'
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img'
import InitialData from '../../vue/data-components/InitialData.vue'
import LiveProductData from '../../vue/data-components/LiveProductData.vue'
import AdvCart from './AdvCart'
import AdvProductCard from './AdvProductCard.vue'
import AdvButtonViewBuy from './AdvButtonViewBuy.vue'
import AdvCartProductList from './AdvCartProductList.vue'
import AdvCartGiftList from './AdvCartGiftList.vue'
import AdvProductGallery from './AdvProductGallery.vue'
import AdvProductGalleryWithVideo from './AdvProductGalleryWithVideo.vue'
import LaboSellingPoints from './labosuisse/LaboSellingPoints.vue'

Vue.use(Toasted, { iconPack: 'fontawesome' })
Vue.use(VueTinyLazyloadImg)

window.Vue = new Vue({
  components: {
    InitialData,
    LiveProductData,
    AdvProductCard,
    AdvButtonViewBuy,
    AdvCartProductList,
    AdvCartGiftList,
    AdvProductGallery,
    AdvCart,
    AdvProductGalleryWithVideo,
    LaboSellingPoints
  },
  computed: {
    countCartProducts () {
      return store.getters.cartProductsCount
    },
    countCartProductPieces () {
      return store.getters.cartProductPiecesCount
    },
    cartHasProduct () {
      return !store.getters.cartEmpty
    },
    cartTotal () {
      return store.getters.cartProductsTotal.toFixed(2)
    },
    productCardModal () {
      return store.getters.productCardModal
    },
    cartProductWeightTotal() {
      return store.getters.cartProductWeightTotal
    }
  },
  methods: {
    closeProductCardModal () {
      store.dispatch('closeProductCardModal')
    },
    checkConnectionStatus () {
      store.dispatch('setOnlineStatus', navigator.onLine)
    }
  },
  created () {
    this.checkConnectionStatus()
    window.addEventListener('offline', this.checkConnectionStatus)
    window.addEventListener('online', this.checkConnectionStatus)
  },
  destroyed () {
    window.removeEventListener('offline', this.checkConnectionStatus)
    window.removeEventListener('online', this.checkConnectionStatus)
  }
}).$mount('#app')
